import styled from 'styled-components'
import { Modal } from '@material-ui/core'

import PerfectScrollbar from 'react-perfect-scrollbar'
import DayPicker from 'react-day-picker'

interface ReportCalendarProps {
  hasReport: boolean
}

interface CalendarProps {
  isDesktop: boolean
}

interface SheetButtonProps {
  isModalButton?: boolean
}

export const SheetButton = styled.button<SheetButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #188038;
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  color: white;
  /* margin-left: auto; */
  cursor: pointer;
  transition: 0.3s ease-in-out;
  font-family: 'Roboto';
  font-weight: bold;
  width: ${({ isModalButton }) => (isModalButton ? '55%' : 'auto')};

  &:hover {
    background: #126d2d;
  }
  &:first-child {
    margin-left: auto;
    margin-right: 12px;
  }

  &:disabled {
    filter: brightness(0.9);
    cursor: not-allowed;
  }

  &:disabled:hover {
    background-color: #188038;
  }
`

export const SheetModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';

  div.content {
    background: white;
    border-radius: 12px;
    padding: 30px;
    width: 500px;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    outline: none !important;
    position: relative;
  }

  h1 {
    font-size: 24px;
    max-width: 80%;
    text-align: center;
    margin-bottom: 20px;
  }

  span {
    text-align: center;
  }

  div.close-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px;
    z-index: 66;
    cursor: pointer;
  }

  div.checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 30px auto;
  }
`

export const HeaderStore = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  height: 48px;
  background: #e5e9eb;

  //Font
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #263238;
`

export const CalendarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const ReportCalendar = styled.div<ReportCalendarProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #c4c4c4;
  background-color: #fff;
  border-radius: 4px;
  gap: 5px;
  padding: 10px 18px;
  width: 100%;
  cursor: ${({ hasReport }) => (hasReport ? 'pointer' : 'not-allowed')};
`

export const Calendar = styled.div<CalendarProps>`
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 1000;
  left: ${props => (props.isDesktop ? '347px' : '107px')};
  margin-top: -10px;
  /* background-color: #fff; */
  padding: 6px 4px;
  border-radius: 4px;
  /* border: 1px solid #c4c4c4; */
`

export const Picker = styled(DayPicker)`
  font-family: 'Roboto';

  .DayPicker-Month {
    margin: 0;
  }

  .DayPicker-Day--outside {
    color: #e1e1e1 !important;
    cursor: not-allowed;
    pointer-events: none;
    background-color: #fff !important;
  }

  .DayPicker-Day--selected {
    background-color: #e7f3fd !important;
    color: #4a90e2 !important;
  }

  .DayPicker-Day--unUtilDay {
    color: #c1c1c1 !important;
  }

  .DayPicker-Day--start {
    background-color: #4a90e2 !important;
    color: white !important;
    border-radius: 30px 0px 0px 30px !important;
    font-weight: 600;
    pointer-events: none;
  }

  .DayPicker-Day--end,
  .DayPicker-Day--hoverDay {
    background-color: #4a90e2 !important;
    color: white !important;
    border-radius: 0px 30px 30px 0px !important;
    font-weight: 600;
    cursor: pointer;
  }

  .DayPicker-Day--to {
    background-color: #4a90e2 !important;
    color: white;
    border-radius: 30px 0px 0px 30px !important;
    font-weight: 600;
  }

  .DayPicker-Day--from {
    background-color: #4a90e2 !important;
    color: white;
    border-radius: 30px 0px 0px 30px !important;
    font-weight: 600;
  }

  .DayPicker-Day--startEnd {
    border-radius: 50% !important;
  }
  .DayPicker-NavButton {
    margin-top: -14px;
  }

  .DayPicker-Weekdays {
    border-bottom: 1px solid #eeeeee;
  }

  .DayPicker-Weekday {
    color: #546e7a;
    font-weight: 500;
    font-size: 14px !important;
  }

  .DayPicker-Day {
    font-family: 'Roboto', sans-serif !important;
    border-radius: 0px;
    width: 25px;
  }

  .DayPicker-Day--today {
    font-weight: normal;
  }

  .DayPicker-Day--disabled:not(.DayPicker-Day--outside) {
    color: #e1e1e1 !important;
    cursor: not-allowed;
    pointer-events: none;
    background-color: #fff !important;
  }
`

export const VisiblePerfectScrollbar = styled(PerfectScrollbar)`
  .ps__rail-x {
    opacity: 0.6;
  }

  .ps__thumb-x {
    height: 11px;
  }
`

// Bloco de conversão. Medidas e cores conferidas contra o HTML do design.
export const ConversionChip = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 44px;
  gap: 10px;
  padding: 0 14px 0 6px;
  background: #fff;
  border: 1px solid #d3d7de;
  border-radius: 4px;
  font-family: 'Roboto';
  white-space: nowrap;

  div.icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background: #eef0fb;

    svg {
      width: 18px;
      height: 18px;
      color: #2c3ec8;
    }
  }

  span.label {
    color: #5f6670;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.6px;
  }

  span.rate {
    color: #1f2fa8;
    font-size: 18px;
    font-weight: 700;
  }

  span.divider {
    width: 1px;
    height: 20px;
    background: #e3e6eb;
  }

  span.detail {
    color: #5f6670;
    font-size: 13px;

    strong {
      color: #1f2328;
      font-weight: 500;
    }
  }

  span.info {
    display: flex;
    align-items: center;
    color: #8a919c;
    cursor: help;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`

export const ChartTabs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 0 24px;
  font-family: 'Roboto';
`

export const ChartTabList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

interface ChartTabProps {
  active: boolean
}

export const ChartTab = styled.button<ChartTabProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 56px;
  margin-bottom: -1px;
  padding: 0 14px;
  background: transparent;
  border: none;
  border-bottom: 2px solid ${({ active }) => (active ? '#2c3ec8' : 'transparent')};
  color: ${({ active }) => (active ? '#1f2fa8' : '#5f6670')};
  cursor: pointer;
  font-family: 'Roboto';
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.4px;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    color: #1f2fa8;
  }
`

export const ChartLegend = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  color: #5f6670;
  font-size: 12px;

  div.item {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  span.box {
    border-radius: 2px;
    height: 10px;
    width: 10px;
  }

  span.dash {
    border-top: 2px dashed #d64545;
    width: 16px;
  }
`

export const ChartSubtitle = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 14px;
  color: #5f6670;
  font-family: 'Roboto';
  font-size: 13px;

  strong {
    font-weight: 700;

    &.hour {
      color: #1f2328;
    }

    &.metric {
      color: #1f2fa8;
    }
  }
`

const PLOT_HEIGHT = '220px'
const AXIS_WIDTH = '36px'
const AXIS_GAP = '8px'
// Faixa reservada à direita para o rótulo da média. Fora da área das barras, o
// rótulo nunca disputa espaço com elas e dispensa fundo para se destacar.
const AVERAGE_WIDTH = '64px'

export const ChartBody = styled.div`
  display: flex;
  gap: ${AXIS_GAP};
  font-family: 'Roboto';
`

export const ChartYAxis = styled.div`
  position: relative;
  flex-shrink: 0;
  width: ${AXIS_WIDTH};
  height: ${PLOT_HEIGHT};

  span {
    position: absolute;
    right: 0;
    transform: translateY(-50%);
    color: #8a919c;
    font-size: 11px;
  }
`

export const ChartPlot = styled.div`
  position: relative;
  flex-grow: 1;
  height: ${PLOT_HEIGHT};

  div.grid {
    position: absolute;
    left: 0;
    right: 0;
    border-top: 1px solid #eceef2;

    &.base {
      border-top-color: #c9cdd4;
    }
  }

  div.average {
    position: absolute;
    left: 0;
    right: 0;
    border-top: 2px dashed #d64545;
    pointer-events: none;
    /* As barras vêm depois no DOM: sem isto elas pintam por cima da linha. */
    z-index: 2;
  }

  div.bars {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: flex-end;
    gap: 14px;
    padding: 0 10px;
  }
`

interface ChartBarProps {
  active: boolean
}

export const ChartBar = styled.div<ChartBarProps>`
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 4px;
  cursor: default;

  span.value {
    color: ${({ active }) => (active ? '#1f2328' : '#5f6670')};
    font-size: 11px;
    font-weight: ${({ active }) => (active ? 700 : 500)};
  }

  div.bar {
    width: 100%;
    max-width: 56px;
    border-radius: 3px 3px 0 0;
    box-shadow: ${({ active }) =>
      active ? '0 0 0 2px #fff, 0 0 0 4px #1f2fa8' : 'none'};
  }
`

export const ChartAverage = styled.div`
  position: relative;
  flex-shrink: 0;
  width: ${AVERAGE_WIDTH};
  height: ${PLOT_HEIGHT};

  span {
    position: absolute;
    left: 6px;
    transform: translateY(50%);
    color: #b83232;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
  }
`

export const ChartXAxis = styled.div`
  display: flex;
  gap: 14px;
  margin-left: calc(${AXIS_WIDTH} + ${AXIS_GAP});
  margin-right: calc(${AVERAGE_WIDTH} + ${AXIS_GAP});
  padding: 6px 10px 0;
  font-family: 'Roboto';

  div.tick {
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }

  span.hour {
    color: #3c4250;
    font-size: 12px;
    font-weight: 500;
  }

  span.detail {
    color: #8a919c;
    font-size: 11px;
  }
`

export const ChartFooter = styled.div`
  display: flex;
  align-items: center;
  height: 64px;
  margin-top: 20px;
  border-top: 1px solid #eef0f3;
  font-family: 'Roboto';

  div.item {
    display: flex;
    flex: 1 1 0;
    min-width: 0;
    flex-direction: column;
    gap: 2px;

    & + div.item {
      border-left: 1px solid #eef0f3;
      padding-left: 20px;
    }
  }

  span.title {
    color: #5f6670;
    font-size: 11px;
    letter-spacing: 0.6px;
  }

  span.value {
    color: #1f2328;
    font-size: 15px;
    font-weight: 700;
  }

  span.soft {
    color: #5f6670;
    font-size: 12px;
    font-weight: 400;
  }

  span.best {
    color: #1e7e34;
  }

  span.worst {
    color: #d32f2f;
  }

  span.hint {
    color: #3c4250;
    font-size: 13px;
  }
`
